import { mainRoutes } from './main/routes';
import { indexesRoutes } from './indexes/routes';
import { type RouteRecordRaw } from 'vue-router';
import { notificationsRoutes } from './notifications/routes';
import { supportRoutes } from './support/routes';
import { configurationsRoutes } from './configurations/routes';
import { kiEngineRoutes } from './ki-engines/routes';
import { chatRoutes, ROUTE_CHAT_ROOT } from './chat/routes';
import { exploreGptRoutes } from './chatbots/routes';
import { profilesRoutes } from './profiles/routes';
import { usersRoutes } from './users/routes';

const appRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'autheris-login',
    component: () => import('src/pages/autheris-login.vue'),
  },
  {
    ...mainRoutes,
    children: [
      chatRoutes,
      indexesRoutes,
      supportRoutes,
      kiEngineRoutes,
      exploreGptRoutes,
      notificationsRoutes,
      configurationsRoutes,
      profilesRoutes,
      usersRoutes
    ],
    redirect: {
      name: ROUTE_CHAT_ROOT,
    },
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('src/pages/error-not-found.vue'),
  },
];

export default appRoutes;
